import { Logger } from 'simple-logging-lib';
import { apiClientWithMiddleware } from '../../../utils/API';
import { captureUndefinedPortalError, getApiConfigs } from './api-utils';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { DataFetchingError } from '../../../errors/DataFetchingError';
const NOTIFICATION_STATION_API_V3_URL = 'notification-station/general/v3/notifications';
export const getUnreadCount = async () => {
  const {
    queryConfig
  } = getApiConfigs();
  if (!queryConfig.query.portalId) {
    captureUndefinedPortalError();
    return {
      counter: 0,
      hasMore: false
    };
  }
  const client = apiClientWithMiddleware();
  const query = {
    portalId: queryConfig.query.portalId,
    show_unread_only: true
  };
  try {
    const response = await client.getWithResponse(`${NOTIFICATION_STATION_API_V3_URL}/count`, {
      query
    });
    return response.data;
  } catch (e) {
    const cause = e;
    const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
    const error = new DataFetchingError('Failed to fetch unread count', {
      cause,
      statusCode: cause.status
    });
    logger.error(error);
    return {
      counter: 0,
      hasMore: false
    };
  }
};